import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { PersonAvatar } from '@factorialco/factorial-one-react/dist/experimental'
import {
  FilterType,
  buildTrainingsDataTableFilter,
  useTrainingsDataTable,
} from 'generated/resources/datatable.graphql'
import { ParticipantEmployeeFragment } from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

export const employeeFilter = (
  source: ReturnType<typeof useTrainingsDataTable>,
  employees: ParticipantEmployeeFragment[]
) => {
  const options = employees.map((employee) => {
    return {
      label: employee.fullName,
      value: employee.accessId,
      component: (
        <Box flexDirection="row" alignItems="center" gap="s8">
          <PersonAvatar
            size="small"
            firstName={employee.fullName}
            lastName=""
            src={buildUrl(employee.avatar?.url)}
          />
          <Text.Normal weight="medium">{employee.fullName}</Text.Normal>
        </Box>
      ),
    }
  })

  return buildTrainingsDataTableFilter(source, {
    type: FilterType.Integer,
    default: true,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
    identifier: 'employeesFilter',
    path: 'accessId',
    title: i18n.t('trainings.trainings_table.participant'),
    onUpdateValue: () => {
      track(trackingEvents.training.trainingsFilters.participantFilter)
      track(trackingEvents.training.trainingRequest.filterPublicTrainings, {
        filter_used: 'Employee',
      })
    },
  })
}
